// src/hooks/usePipelineStages.js
// SEAM 4 VERIFIER: qpipe-4d1a7c35-hook
//
// Live stage list for an org, from organizations/{orgId}/settings/pipeline
// (staff-read, server-write). Falls back to the starter template while the
// document doesn't exist yet. Returns null until the first snapshot arrives.
// Operator surfaces only — portal customers cannot read this document.
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { resolvePipelineStages } from '../utils/quoteSchema';

export default function usePipelineStages(orgId) {
    const [stages, setStages] = useState(null);

    useEffect(() => {
        if (!orgId) { setStages(null); return undefined; }
        return onSnapshot(
            doc(db, `organizations/${orgId}/settings`, 'pipeline'),
            (snap) => setStages(resolvePipelineStages(snap.exists() ? snap.data() : null)),
            (err) => {
                console.warn('usePipelineStages: subscription failed', err);
                setStages(null);
            }
        );
    }, [orgId]);

    return stages;
}
